import { render } from "./vuetable.vue?vue&type=template&id=315bfc51&scoped=true&lang=pug"
import script from "./vuetable.vue?vue&type=script&lang=js"
export * from "./vuetable.vue?vue&type=script&lang=js"

import "./vuetable.vue?vue&type=style&index=0&id=315bfc51&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-315bfc51"]])

export default __exports__